import TierPrize from './tier_prize'

// import middlewares
export default [{
  path: '/tier-prize',
  component: TierPrize,
  name: 'TierPrize'
}]
